// console.log(`features block is working!`);

const setInitialOpenFeature = (featureButton, featureCollapse, i) => {
  /**
   * Sets the initial state for the first feature accordion
   * when the page loads.
   */
  featureButton.classList.add(`collapsed`);
  featureCollapse.classList.remove(`show`);
  if (i === 0) {
    featureCollapse.classList.add(`show`);
    featureButton.classList.remove(`collapsed`);
  }
};

const setAccordionDataAttr = (feature, featureButton, featureCollapse) => {
  /**
   * Sets data-bs-parent in mobile views. This ensures the
   * accordion operates correctly on mobile devices
   */
  featureCollapse.dataset.bsParent = `#` + feature.id;

  /**
   * Sets data-bs-target and data-bs-toggle in mobile views.
   * This ensures the accordion operates correctly on mobile devices
   */
  featureButton.dataset.bsTarget = `#` + featureCollapse.id;
  featureButton.dataset.bsToggle = `collapse`;
};

/**
 * In mobile views this clones the feature icon container, adds it
 * next the accordion title, and removes previous icon from the DOM.
 */
const cloneFeatureIcon = (feature, featureButton) => {
  let featureIconContainer = feature.querySelector(`.feature-icon-container`);
  let newIconContainer = featureIconContainer.cloneNode(true);
  let featureAccordionHeader = feature.querySelector(`.accordion-header`);
  featureAccordionHeader.insertBefore(newIconContainer, featureButton);
  featureIconContainer.remove();
};

const featuresBlock = document.querySelector(`#features`);
const windowSize = document.querySelector(`body`).clientWidth;

if (featuresBlock && windowSize < 992) {
  const featureContainer = document.querySelectorAll(
    `.accordion.feature-container`
  );
  featureContainer.forEach((feature, i) => {
    let featureAccordionButton = feature.querySelector(
      `.accordion-header button`
    );
    let featureCollapse = feature.querySelector(`.accordion-collapse`);

    setInitialOpenFeature(featureAccordionButton, featureCollapse, i);
    setAccordionDataAttr(feature, featureAccordionButton, featureCollapse);
    cloneFeatureIcon(feature, featureAccordionButton);
  });
}
